import { getInstance } from './authWrapper';

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const guardRoute = () => {
    if (authService.isAuthenticated) {
      return next();
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return guardRoute();
  }

  authService.$watch('loading', (loading) => {
    if (loading === false) {
      return guardRoute();
    }
  });
};
